import * as React from 'react';
import { Paper } from 'ui';
import { UserProfileTranslation } from 'app/area/user-profile/constants';
import { UserProfileSectionHeading } from 'app/area/user-profile/user-profile-section-heading';
import { TileWrapper } from 'app/components/tile-wrapper/tile-wrapper';
import { GroupText } from 'app/components/group-text/group-text';
import { noContentSectionId } from 'app/area/user-profile/subscriptions/constants';
import { UserProfileHeading } from 'app/area/user-profile/user-profile-heading';

interface NoContent {
  translation: UserProfileTranslation;
  componentId?: string;
}

export const NoContent = ({ translation, componentId = noContentSectionId }: NoContent) =>
  <Paper componentId={componentId} className="user-profile-section-paper">
    <UserProfileHeading title={translation.main_title} />
    <UserProfileSectionHeading
      sectionTitle={translation.subscriptions_section_title}
      disclaimer={translation.subscriptions_section_disclaimer} />
    <section>
      <div className="main-grid">
        <TileWrapper>
          <GroupText>{translation.subscribed_text}</GroupText>
          <div className="row">
            <div className="col-md-12 mt-1 mb-3">
              <p className="no-content mt-2">{translation.no_subscriptions}</p>
            </div>
          </div>
        </TileWrapper>
      </div>
    </section>
  </Paper>;
